import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contact() {
  const [contact, setContact] = useState({});
  const location = useLocation();
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const slug = location.pathname.split("/").filter(Boolean).pop();
  const getContact = async() => {
    try {
      const response = await fetch(`${baseurl}get-pages.php/${slug}`);
      const result = await response.json();
      setContact(result.data.length > 0 && result.data[0]); // Adjust based on your API response       
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {}
  };
  useEffect(()=>{
    getContact()
  },[])
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    query: ''
  });
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    phone: '',
    query: '',
  });
    
  const validateForm = () => {
    let valid = true;
    let newErrors = { name: '', email: '', phone: '', query: '' };

    if (!formData.name) {
      newErrors.name = 'Name is required';
      valid = false;
    }

    if (!formData.phone) {
      newErrors.phone = 'Phone is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone is invalid";
    }

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
      valid = false;
    }

    if (!formData.query) {
      newErrors.query = 'Message is required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      fetch(`${baseurl}contact-us.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(result => {
        if(result){
          toast("Something went wrong. Please try late!");
        }else {
          toast("Thanks for contacting us. We are get back to you shortly!");
          setFormData({
            name: '',
            email: '',
            phone: '',
            query: '',
          });
        }
      })
      .catch(error => {
          console.error('Error:', error);
      });      
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
        <ToastContainer />
        <section id="home" className={`${styles.hero} ${styles.about_banner}`} data-aos="fade-up" style={{backgroundImage:`url(${contact.banner_image})`}}>
            <div className="container">
                <div className='row'>
                    <div className="col-md-12">            
                        <h1 className='font-bold leading-12 text-5xl'>Contact Us</h1>
                        <p className="text-white text-xl font-semibold mt-2 mb-0 w-2/5">Contact meetup today & let's embark on a journey towards on exceptional event partnership</p>
                    </div>
                </div>
            </div>
        </section>
        <section className='py-20'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-7">
                        <div dangerouslySetInnerHTML={{__html: contact.description}}/>
                    </div>
                    <div className="col-md-5">
                        <form>
                            <div className={`relative ${errors.name ? "": "mb-4"}`}>
                                <input type="text" id="name" name="name"
                                className="block px-2.5 pb-2.5 pt-4 w-full text-l text-gray-300 bg-transparent border-b border-slate-200 peer focus:outline-none" placeholder=" " 
                                value={formData.name}
                                onChange={handleChange} />
                                <label htmlFor="name" className='absolute text-l text-gray-300 duration-300 transform -translate-y-5 top-2 z-10 px-1 peer-placeholder-shown:-translate-y-1/4 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/5 rtl:peer-focus:left-auto start-1'>Your Name</label>
                            </div>
                            {errors.name && <p className={`error text-rose-600 px-1 mt-1 ${errors.name ? "mb-4": ""}`}>{errors.name}</p>}
                            <div  className={`relative ${errors.email ? "": "mb-4"}`}>
                                <input type="email" id="email" name="email"
                                className="block px-2.5 pb-2.5 pt-4 w-full text-l text-gray-300 bg-transparent border-b border-slate-200 peer focus:outline-none" placeholder=" " 
                                value={formData.email}
                                onChange={handleChange} />
                                <label htmlFor="email" className='absolute text-l text-gray-300 duration-300 transform -translate-y-5 top-2 z-10 px-1 peer-placeholder-shown:-translate-y-1/4 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/5 rtl:peer-focus:left-auto start-1'>Your Email</label>
                            </div>
                            {errors.email && <p className={`error text-rose-600 px-1 mt-1 ${errors.email ? "mb-4": ""}`}>{errors.email}</p>}
                            <div  className={`relative ${errors.phone ? "": "mb-4"}`}>
                                <input type="email" id="phone" name="phone"
                                className="block px-2.5 pb-2.5 pt-4 w-full text-l text-gray-300 bg-transparent border-b border-slate-200 peer focus:outline-none" placeholder=" " 
                                value={formData.phone}
                                onChange={handleChange} />
                                <label htmlFor="phone" className='absolute text-l text-gray-300 duration-300 transform -translate-y-5 top-2 z-10 px-1 peer-placeholder-shown:-translate-y-1/4 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/5 rtl:peer-focus:left-auto start-1'>Your Phone</label>
                            </div>
                            {errors.phone && <p className={`error text-rose-600 px-1 mt-1 ${errors.phone ? "mb-4": ""}`}>{errors.phone}</p>}
                            <div className={`relative ${errors.query ? "": "mb-4"}`}>
                                <textarea id="message" name="query"
                                className="resize-none block px-2.5 pb-2.5 pt-4 w-full text-l text-gray-300 bg-transparent border-b border-slate-200 peer focus:outline-none" placeholder=" " 
                                value={formData.query}
                                rows={4}
                                onChange={handleChange} />
                                <label htmlFor="message" className='absolute text-l text-gray-300 duration-300 transform -translate-y-5 top-2 z-10 px-1 peer-placeholder-shown:-translate-y-1/4 peer-placeholder-shown:top-1/4 peer-focus:top-2 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/5 rtl:peer-focus:left-auto start-1'>Your text</label>
                            </div>
                            {errors.query && <p className={`error text-rose-600 px-1 mt-1 ${errors.query ? "mb-4": ""}`}>{errors.query}</p>}
                            <button onClick={handleSubmit} className="text-sm mt-6 p-2 px-4 border-yellow-400 border-1 text-yellow-400 rounded-pill outline-none">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Contact